import { useCallback } from "react";

import { commitMutation } from "relay-runtime";

import { environment } from "~/models";
import { attendanceMutation } from "~/nav/panels/Meetings";
import toast from "~/ui/toast";

import type {
	EventEditType,
	MeetingsPanelAttendanceMutation,
	ResponseStatusChoices,
} from "~/__generated__/MeetingsPanelAttendanceMutation.graphql";

type useEventAttendanceMutationVariables = {
	calendarId: string;
	eventId: string;
	eventGuid: string;
	eventTitle: string;
	userResponseStatus: ResponseStatusChoices;
	editType: EventEditType;
	setMutationLoading: (loading: boolean) => void;
	onAnsweredRsvp?: () => void;
};

export default function useEventAttendanceMutation() {
	return useCallback(
		async ({
			calendarId,
			eventId,
			eventGuid,
			eventTitle,
			userResponseStatus,
			editType,
			setMutationLoading,
			onAnsweredRsvp,
		}: useEventAttendanceMutationVariables): Promise<void> => {
			setMutationLoading(true);
			if (onAnsweredRsvp) onAnsweredRsvp();
			commitMutation<MeetingsPanelAttendanceMutation>(environment, {
				mutation: attendanceMutation,
				variables: {
					calendarId: calendarId,
					guid: eventGuid,
					userResponseStatus,
					editType,
				},
				onCompleted: () => {
					let answer = "";
					if (userResponseStatus === "accepted") {
						answer = "Yes";
					} else if (userResponseStatus === "declined") {
						answer = "No";
					} else if (userResponseStatus === "tentative" || userResponseStatus === "tentativelyAccepted") {
						answer = "Maybe";
					}

					toast.info(`Responded "${answer}" to "${eventTitle}"`);
					setMutationLoading(false);
				},
				optimisticUpdater: store => {
					const record = store.get(eventId);
					if (!record) return;
					record?.setValue(userResponseStatus, "userResponseStatus");
				},
			});
		},
		[],
	);
}
